import React from 'react'
import { DiReact, DiMongodb, DiPython, DiJavascript1 } from 'react-icons/di'
import { SiFirebase, SiAmazonaws, SiPostgresql, SiMysql, SiGooglecloud, SiFastapi, SiOpencv, SiRaspberrypi, SiDocker } from 'react-icons/si'

const row1 = [
  [<DiPython />, 'Python'], [<SiFastapi />, 'FastAPI'], [<SiOpencv />, 'OpenCV'], [<SiAmazonaws />, 'AWS'],
  [<SiGooglecloud />, 'GCP'], [<SiDocker />, 'Docker'], [<SiRaspberrypi />, 'Raspberry Pi'],
]
const row2 = [
  [<DiReact />, 'React'], [<DiJavascript1 />, 'JavaScript'], [<DiMongodb />, 'MongoDB'],
  [<SiPostgresql />, 'PostgreSQL'], [<SiMysql />, 'MySQL'], [<SiFirebase />, 'Firebase'],
]

function Row({ items, reverse }) {
  const list = [...items, ...items, ...items, ...items]
  return (
    <div className={`marquee-row ${reverse ? 'reverse' : ''}`}>
      <div className="marquee-track">
        {list.map(([icon, label], i) => (
          <span className="marquee-item" key={i} aria-hidden={i >= items.length}>
            {icon}<em>{label}</em>
          </span>
        ))}
      </div>
    </div>
  )
}

function TechMarquee() {
  return (
    <div className="marquee" aria-label="Technologies I work with">
      <Row items={row1} />
      <Row items={row2} reverse />
    </div>
  )
}

export default TechMarquee
